import { IntegrationType } from '@models/integration.model';

export enum DiscrepancyType {
  PROCESS_IMPROVEMENT = 'PROCESS_IMPROVEMENT',
  POLICY_NOT_FOUND = 'POLICY_NOT_FOUND',
  POLICY_NOT_CREATED = 'POLICY_NOT_CREATED',
  PROCESS_NOT_UPDATED = 'PROCESS_NOT_UPDATED',
  TRIGGER_CALENDAR_NOT_FOUND = 'TRIGGER_CALENDAR_NOT_FOUND',
}

export interface DiscrepancyData {
  discrepancyType?: DiscrepancyType;
  entityId?: string;
  entityName?: string;
  entity?: string;
  discrepancyTypeExplanation?: string;
  discrepancyDetailsTitle?: string;
  discrepancyDetailsContent?: string[];
  coherenceCheck?: any;
  optionP?: string;
  optionPMessage?: string;
  optionI?: string;
  optionIMessage?: string;
  [key: string]: any;
}

export interface Discrepancy {
  discrepancyParentType?: string;
  discrepancyId?: string;
  integrationType?: IntegrationType;
  discrepancyData?: DiscrepancyData;
  resolution?: ResolutionType;
  ignoreUntil?: Date;
  createdAt?: string;
  lastUpdatedAt?: string;
  deletedAt?: string;
  navigateTo?: string;
}

export interface ShownDiscrepancy extends Discrepancy {
  title: string;
}

export enum ResolutionType {
  MATCHED_INTEGRATION = 'MATCHED_INTEGRATION',
  MATCHED_PET = 'MATCHED_PET',
  IGNORE_PERMANENTLY = 'IGNORE_PERMANENTLY',
}

export interface getDiscrepanciesRequest {
  getDiscrepancies: Discrepancy[];
}

export interface getActiveDiscrepanciesRequest {
  getActiveDiscrepancies: Discrepancy[];
}

export interface getActiveDiscrepanciesCountRequest {
  getActiveDiscrepanciesCount: number;
}

export interface ActiveDiscrepanciesAndPendingCountDto {
  activeDiscrepanciesCount: number;
  activePendingCount: number;
}

export interface getActiveDiscrepanciesAndPendingCountRequest {
  getActiveDiscrepanciesAndPendingCount: ActiveDiscrepanciesAndPendingCountDto;
}

export interface updateDiscrepancyRequest {
  updateDiscrepancy: Discrepancy;
}
